export const DEFAULT_SRC = '/gpa-cross-flow/';
export const EXPERIMENTAL_PERFORMANCE_SRC = '/gpa-cross-flow/experimental-index.html';
export const SPA_APP_NAME = 'crossFlowSpa';
